import styled from 'styled-components'

export const FooterRoot = styled.footer`
	display: flex;
	grid-area: footer;
	align-items: center;
	border-top: 1px solid #dcdada;
	padding: 0 10px;
`
